import { ImgHTMLAttributes } from "react";

export default function ApplicationLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
    return (
        <img
            src="/images/nova-agency-logo.svg"
            alt="NOVA Agency"
            {...props}
        />
    );
}
